import {
  SelectFromInfiniteQuery,
  SelectFromInfiniteQueryProps,
} from "./SelectFromInfiniteQuery"
import { useTranslation } from "react-i18next"
import { useDefaultSuspenseInfiniteQuery } from "../../utils/useDefaultSuspenseInfiniteQuery"
import {
  InfiniteData,
  UseSuspenseInfiniteQueryResult,
} from "@tanstack/react-query"
import { getSimplePersons } from "@/orval/gen"
import {
  GetSimplePersonsParams,
  SimplePersonPagination,
} from "@/orval/gen/model"

interface Props
  extends Omit<
    SelectFromInfiniteQueryProps<
      UseSuspenseInfiniteQueryResult<InfiniteData<SimplePersonPagination>>
    >,
    "queryData" | "entitiesToComboboxData"
  > {
  filterOptions?: Omit<
    GetSimplePersonsParams,
    "pageParam" | "pageSize" | "searchValue"
  >
}

export function InfinitePersonMultiSelect({
  filterOptions = {},
  ...props
}: Props) {
  const { t } = useTranslation("app_server")
  const [searchValue, setSearchValue] = React.useState("")

  return (
    <SelectFromInfiniteQuery
      multiple={true}
      searchValue={searchValue}
      onSearchChange={setSearchValue}
      entitiesToComboboxData={(person) => ({
        label: person.name,
        value: person.personId.toString(),
      })}
      label={t("Persons")}
      placeholder={t("SearchPerson")}
      {...props}
      queryData={useDefaultSuspenseInfiniteQuery(
        getSimplePersons,
        (pageRequest) => ({
          ...pageRequest,
          searchValue,
          ...filterOptions,
        })
      )}
    />
  )
}
